import { render, staticRenderFns } from "./CreateExpenseType.vue?vue&type=template&id=2c67c70e"
import script from "./CreateExpenseType.vue?vue&type=script&lang=js"
export * from "./CreateExpenseType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports